class HeroVideo extends HTMLElement {
  constructor() {
    super();
    this.videoElement = null;
    this.isUserPaused = false;
  }

  connectedCallback() {
    const template = this.querySelector('template');

    if (template && !this.querySelector('video')) {
      this.appendChild(template.content.cloneNode(true));
    }

    this.videoElement = this.querySelector('video');
    const buttons = this.querySelectorAll('[id^="DeferredPoster-"]');

    if (!this.videoElement || buttons.length === 0) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => this.toggleVideo(), { passive: true });
    });

    if (!window.heroVideoObserver) {
      const initObserver = () => {
        window.heroVideoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const mediaEl = entry.target;

            if (entry.isIntersecting && !mediaEl.isUserPaused) {
              mediaEl.playVideo();
            } else if (!entry.isIntersecting) {
              mediaEl.pauseVideo(false);
            }
          });
        });
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(initObserver);
      } else {
        initObserver();
      }
    }

    if (window.heroVideoObserver) {
      window.heroVideoObserver.observe(this);
    }
  }

  disconnectedCallback() {
    if (window.heroVideoObserver) {
      window.heroVideoObserver.unobserve(this);
    }
  }

  toggleVideo() {
    if (this.videoElement.paused) {
      this.playVideo();
    } else {
      this.pauseVideo(true);
    }
  }

  playVideo() {
    this.isUserPaused = false;

    if (this.videoElement) {
      this.videoElement.play().catch((error) => {
        console.error('Error playing video:', error);
      });
      this.toggleButtonState(true);
    }
  }

  pauseVideo(userInitiated = true) {
    if (userInitiated) {
      this.isUserPaused = true;
    }

    if (this.videoElement && !this.videoElement.paused) {
      this.videoElement.pause();
      this.toggleButtonState(false);
    }
  }

  toggleButtonState(isPlaying) {
    this.querySelectorAll('[id^="DeferredPoster-"]').forEach((button) => {
      button.classList.toggle('is-playing', isPlaying);
      button.classList.toggle('is-paused', !isPlaying);
    });
  }
}

customElements.define('video-media', HeroVideo);
